import React from 'react'
import {ServerConfig} from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const Ecocontrols = () => {
  const non_editable_fields = [
    ["id", "id", ""],
    ["owner", "Owner", "tenant"],
    ["tenant_site_id", "Site", "tenantsite"],
    ["secret", "secret", ""],
  ];

  const editable_fields = [
    ["name", "Name"],
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/tenant/ecocontrols`}
        detail_get_url={`${ServerConfig.SERVER_URL}/tenant/ecocontrols/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/tenant/ecocontrols/`}

        column_names={["id", "tenant_site_id", "name"]}
        header_names={["id", "site", "name"]}

        optional_column_names={[]}
        optional_header_names={[]}

        filter_inputs={[]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        show_machine_stats={false}
      />
    </>
  )
}

export default Ecocontrols
